<template>
  <div>
    <h2>Present Levels <span v-if="!loadingResources" class="count">({{ presentlevels.length }})</span></h2>
    <subject-filter
      :subjects="filterOptions"
      :resource="resourceType"
      :page="'library'"/>
    <p v-if="presentlevels.length === 0 && !shared" class="empty-notice">
      <router-link :to="{name: 'PresentLevelsNewWizard'}">Create a present levels statement</router-link>
    </p>
    <div :key="presentlevel.uuid" v-for="presentlevel in filteredPresentLevels">
      <LibraryPresentLevelsCard :present-level="presentlevel" :shared="shared"/>
    </div>
  </div>
</template>

<script>
import LibraryPresentLevelsCard from '@/components/library/LibraryPresentLevelsCard'
import SubjectFilter from '@/components/favorites/SubjectFilter'
import { CONTENT_TYPES } from '@/util/access_visibility'
import { mapState } from 'vuex'

export default {
  name: 'PresentLevelsLibrary',
  components: {
    LibraryPresentLevelsCard,
    SubjectFilter
  },
  props: {
    presentlevels: {
      type: Array,
      required: true
    },
    shared: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      resourceType: CONTENT_TYPES.PRESENTLEVEL
    }
  },
  computed: {
    ...mapState('library', ['filters', 'loadingResources']),
    filteredPresentLevels() {
      let filteredPresentLevels = [].concat(this.presentlevels)
      let subjectFilter = this.filters[this.resourceType]

      if (subjectFilter !== 'All Subjects') {
        filteredPresentLevels = this.presentlevels.filter(pl => {
          return pl.content_body.selected_subjects.indexOf(subjectFilter) !== -1
        })
      }

      filteredPresentLevels.sort((pl1, pl2) => {
        if (pl1.created_at < pl2.created_at) {
          return 1
        }
        if (pl1.created_at > pl2.created_at) {
          return -1
        }
        return 0
      })

      return filteredPresentLevels
    },
    filterOptions() {
      var options = ['All Subjects']
      this.presentlevels &&
        this.presentlevels.forEach(presentlevel => {
          presentlevel.content_body.selected_subjects.forEach(subject => {
            if (options.indexOf(subject) === -1) {
              options.push(subject)
            }
          })
        })
      return options
    }
  }
}
</script>

<style scoped lang="less">
@import '~@/variables.less';
.count {
  color: @blue;
  font-weight: 300;
}
.empty-notice {
  font-size: 24px;
}
</style>
